<div class="card width100 logo">
  <div class="pad-left pad-top">
       <div class="header-text">At a Glance</div>
       <div class="subheader-text hideportrait">DBS Sustainability Accelerator Tool</div>
  </div>
  <div class="pad-left pad-top row">
     <div class="welcome-header-text column1">
       <div class="subheader-text hidelandscape">DBS Sustainability Accelerator Tool</div>
       <div class="subheader-subline">
         Our <a target=_blank href="https://www.dbs.com.sg/sme/businessclass/Catalysts-of-Sustainability-ebook.pdf?utm_source=pweb&utm_medium=banner&utm_campaign=bchomepagebanner&pid=">DBS Catalysts of Sustainability e-book</a> found that the majority of Small and Medium-Sized Enterprises (SMEs) across Singapore, Hong Kong, India, Indonesia, mainland China and Taiwan face challenges in accessing expertise, finance and technology necessary to embrace sustainability fully.
         <br/><br/>
         To bridge this gap and enable SMEs to accelerate in their sustainability journey, DBS has partnered with Deloitte to launch the DBS Sustainability Accelerator Tool.
         <br/><br/>
         This online assessment tool enables businesses to assess their sustainability efforts and provides actionable recommendations for sustainability progress across four key pillars.
         <br/><br/><br/>
         <button class="start-button" (click)="startClick()">START NOW</button>
       </div>
     </div>
     <div class="welcome-header-image column1">
         <img class="welcome-image" src="assets/images/welcome0.jpg">
     </div>
  </div>
  <div class="pad-left pad-top-more">
     <div class="subheader-subline">
       The tool enables businesses to assess your sustainability efforts with actionable recommendations for progress across four key pillars:
     </div>
  </div>
  <div class="pad-left row">
     <div class="column2 showborder">
       <div class="pillar-header">
         Pillar 1<br/>Governance Framework
       </div>
       <div>
         <img class="welcome-image" src="assets/images/pillar1.jpg">
       </div>       
       <div class="subheader-subline-inner">
         This evaluates your company's governance practices to assess your ethical, transparent decision-making and accountability for sustainable business operations.
       </div>
     </div>
     <div class="column2 showborder">
       <div class="pillar-header">
         Pillar 2<br/>Sustainability Strategy
       </div>
       <div>
         <img class="welcome-image" src="assets/images/pillar2.jpg">
       </div>
       <div class="subheader-subline-inner">
         This evaluates how you develop and implement a roadmap or plan that integrates environmental, social, and governance considerations into the core business operations, fostering long-term sustainable practices and outcomes.
       </div>
     </div>
     <div class="column2 showborder">
       <div class="pillar-header">
         Pillar 3<br/>Risk &amp; Opportunities
       </div>
       <div>
         <img class="welcome-image" src="assets/images/pillar3.jpg">
       </div>
       <div class="subheader-subline-inner">
         This evaluates how your company is identifying and managing potential environmental, social, and governance risks and opportunities while leveraging strategic advantages to drive sustainable growth and innovation.
       </div>
     </div>
     <div class="column2 showborder">
       <div class="pillar-header">
         Pillar 4<br/>Metrics &amp; Targets
       </div>
       <div>
         <img class="welcome-image" src="assets/images/pillar4.jpg">
       </div>
       <div class="subheader-subline-inner">
         This evaluates how you define and measure specific indicators and goals to track and improve your company's environmental, social, and governance performance over time.
       </div>
     </div>
  </div>
  <div class="pad-left pad-top">
     <div class="subheader-text2">
       Why use the DBS Sustainability Accelerator Tool?
     </div>
  </div>
  <div class="pad-left pad-top">
     <div class="subheader-subline3">
       If you are a business looking to kickstart or accelerate your sustainability journey, the DBS Sustainability Accelerator Tool is your key to success. Here’s why:
     </div>
  </div>
  <div class="pad-left pad-top row">
     <div class="column3">
       <div class="row">
         <div class="column4">
           <img class="tool-image" src="assets/images/welcome1.jpg">
         </div>
         <div class="column4">
           <div class="subheader-text3">
             Measure Your Sustainability Readiness
           </div>
           <div class="subheader-subline-inner">
             Get a clear snapshot of where your business stands in the sustainability roadmap. Our tool assesses your current sustainability practices and identifies areas for improvement.
           </div>
         </div>
       </div>
       <div class="row">
         <div class="column4">
           <img class="tool-image" src="assets/images/welcome3.jpg">
         </div>
         <div class="column4">
           <div class="subheader-text3">
             Access Financial Support
           </div>
           <div class="subheader-subline-inner">
             Unlock opportunities for sustainable financing. Our tool helps you identify funding options, grants and incentives to support your sustainability initiatives.
           </div>
         </div>
       </div>
       <div class="row">
         <div class="column4">
           <img class="tool-image" src="assets/images/welcome5.jpg">
         </div>
         <div class="column4">
           <div class="subheader-text3">
             Government Support
           </div>
           <div class="subheader-subline-inner">
             Tap into government programs and incentives. We help you navigate the complex world of sustainability regulations and access available support from local authorities.
           </div>
         </div>
       </div>
     </div>
     <div class="column3">
       <div class="row">
         <div class="column4">
           <img class="tool-image" src="assets/images/welcome2.jpg">
         </div>
         <div class="column4">
           <div class="subheader-text3">
             Actionable Recommendations
           </div>
           <div class="subheader-subline-inner">
             Receive tailored and actionable recommendations to aid your sustainability efforts. We provide concrete steps that cater to your business’ specific needs.
           </div>
         </div>
       </div>
       <div class="row">
         <div class="column4">
           <img class="tool-image" src="assets/images/welcome4.jpg">
         </div>
         <div class="column4">
           <div class="subheader-text3">
             Expert Advisory
           </div>
           <div class="subheader-subline-inner">
             Benefit from expert guidance. We connect you with sustainability consultants who understand your industry and can assist in implementing sustainable practices.
           </div>
         </div>
       </div>
       <div class="row">
         <div class="column1">
         </div>
         <div class="column1">
         </div>
       </div>
     </div>
  </div>
  <div class="pad-left pad-top">
     <div class="subheader-text2">
       Who can benefit from the tool?
     </div>
  </div>
  <div class="pad-left pad-top">
     <div class="subheader-subline2">
       The DBS Sustainability Accelerator tool caters to companies that are:
     </div>
     <div class="subheader-subline2">
       <ul class="pad-left">
          <li class="subheader-subline2">
            Just starting their sustainability efforts and require support and guidance
          </li>
          <li class="subheader-subline2">
            Making good progress in sustainability but finding it tough to grow further
          </li>
          <li class="subheader-subline2">
            Eager to do more and generate a positive impact on sustainability
          </li>
       </ul>
     </div>
  </div>
  <div class="pad-left pad-top">
     <div class="subheader-subline2">
       Receive a tailored report upon assessment completion, evaluating your company’s state of readiness in sustainability and providing strategic recommendations focused on addressing your specific sustainability challenges.
     </div>
  </div>
  <div class="pad-left pad-top pad-bottom">
     <div class="row2">
       <div class="subheader-text4 column5a">
         <div class="row5">
           <div class="column5a1">
             Estimated time to complete:
           </div>
           <div class="column5a2">
             <span class="subheader-red">5 - 10 mins</span>
           </div>
         </div>
       </div>
       <div class="subheader-text5 column5b">
         <button class="start-button" (click)="startClick()">START NOW</button>
       </div>
     </div>
  </div>
  <div class="pad-left pad-top">
     <div class="subheader-subline2">
       By clicking “Start Now”, you confirm that you have read, fully understood and accept the <a target=_blank href="https://www.dbs.com.sg/sme/terms/default.page?pk_source=typed&pk_medium=direct&pk_campaign=bookmarked">Terms and Conditions</a> and <a target=_blank href="https://www.dbs.com/privacy/default.page">DBS Privacy Policy</a> relating to the collection, processing, use of personal data.
     </div>
  </div>
  <div class="pad-left pad-top">
     <div class="row">
       <div class="subheader-subline2 column6a">
         <img class="logo" src="assets/images/welcome6.jpg">
       </div>
       <div class="subheader-subline2 column6b">
         The Sustainability Accelerator Tool is developed in partnership with Deloitte Singapore
       </div>
     </div>
  </div>
</div>
